var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabs" }, [
    _c(
      "div",
      { staticClass: "tabs__header" },
      _vm._l(_vm.tabs, function(tab) {
        return _c(
          "div",
          {
            key: tab.name,
            staticClass: "tabs__header-item",
            class: { "tabs__header-item--active": tab.isActive }
          },
          [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.selectTab(tab)
                  }
                }
              },
              [_vm._v(_vm._s(tab.name))]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tabs__content" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }